import { render, staticRenderFns } from "./BankAccountListingFormDetails.vue?vue&type=template&id=50e3149f&"
import script from "./BankAccountListingFormDetails.vue?vue&type=script&lang=js&"
export * from "./BankAccountListingFormDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports